export enum FileTypesEnum {
    TRIM_ORDERS = 'Trim Order',
    PROJECTION_ORDERS = 'Projection Order'
}